import React from 'react';
import clsx from 'clsx';

import { useListItemStyles } from './style';

type ListItemProps = {
    children: React.ReactNode,
    onClick?: () => void,
    className?: string,
    selected?: boolean,
};

ListItem.defaultProps = {
    onClick: () => {},
    className: '',
    selected: false,
};

function ListItem(props: ListItemProps): React.ReactElement {
    const { children, onClick, className, selected } = props;
    const classes = useListItemStyles();
    return (
        <li className={`${classes.item} ${className} ${selected ? classes.selected : ''}`} onClick={onClick}>
            {children}
        </li>
    );
}

export { ListItem };
